import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Cookies from 'js-cookie';

import Select from "components/Select/Select";
import FormElement from "components/FormElement/FormElement";
import DateInput from "components/DateInput/DateInput";
import SearchInput from "components/SearchInput/SearchInput";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefOrganizations from "table-defs/TableDefOrganizations";
import PageHeader from "components/PageHeader/PageHeader";
// import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
// import useFilterRows from "helpers/customHooks/useFilterRows";
import { toggleDropdowns } from "helpers/utils";

import { loadOrganizationsAction, setPaginationAction } from 'store/actions/Actions';

import styles from "./Dashboard.module.scss";

const DashboardSuper = (props) => {
    const { SuperUserReducer, loadOrganizationsAction, setPaginationAction } = props;

    const [orgs, setOrgs] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [sortBy, setSort] = useState({ sort_by: 'name', sort_direction: 'ASC' });
    const [filterBy, setFilter] = useState({
        name: undefined,
        coach_id: undefined,
        seal_granted_at: undefined,
        seal_expires_at: undefined,
        active: undefined,
    });

    useEffect(() => {
        const timeout = window.setTimeout(() => {
            loadOrganizationsAction({ page, ...sortBy, filterBy });
        }, filterBy.name ? 300 : 0);
        return () => {
            window.clearTimeout(timeout);
        }
    }, [page, sortBy, filterBy]);

    useEffect(() => {
        if (SuperUserReducer.organizations) {
            setOrgs(SuperUserReducer.organizations);
        }
        if (SuperUserReducer.page) {
            setPage(SuperUserReducer.page);
        }
        if (SuperUserReducer.count) {
            setTotal(SuperUserReducer.count);
        }
    }, [SuperUserReducer.organizations, SuperUserReducer.page, SuperUserReducer.count]);

    useEffect(() => {
        setPaginationAction({ dataType: 'organizations', currentPage: 0 });
    }, [filterBy]);

    const handleSearch = (e) => {
        setFilter({
            ...filterBy,
            name: e.target.value.toLowerCase(),
        });
    }

    const handleCoachFilter = (e) => {
        setFilter({
            ...filterBy,
            coach_id: e.target.value || undefined,
        });
    }

    const clearFilters = () => {
        setFilter({
            name: undefined,
            coach_id: undefined,
            seal_granted_at: undefined,
            seal_expires_at: undefined,
            active: undefined,
        });
    }
    const coachDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();

    const coach = SuperUserReducer.coaches && SuperUserReducer.coaches.filter((coach) => coach.coach_id === `${filterBy.coach_id}`)[0] || "";

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                coachDropdownRef,
                statusDropdownRef,
            ])}
            >
                <PageHeader loadStats={false} title="Organizations Overview">
                    <div className={styles.pageHeader}>
                        <div>
                        <SearchInput
                            onChange={handleSearch}
                            value={filterBy.name || ""}
                            size="md"
                            className={`${styles.search} ${props.classNameSearch ? props.classNameSearch : ''}`}
                        />
                        </div>
                        <div className={styles.right}>
                            <div>
                                <FormElement
                                    className={styles["type-filter"]}
                                    htmlFor="rem"
                                >
                                    <Select
                                        value={coach && coach.name || "All Coaches"}
                                        placeholder="Coach name"
                                        size="md"
                                        onClick={handleCoachFilter}
                                        dropdownToggleRef={coachDropdownRef}
                                    >
                                        <li value={undefined} key={"all"}>All Coaches</li>
                                        {SuperUserReducer.coaches && SuperUserReducer.coaches.map(el => (
                                            <li value={el.coach_id} key={el.coach_id}>
                                                {el.name}
                                            </li>
                                        ))}
                                    </Select>
                                </FormElement>
                            </div>
                            <div>
                                <FormElement
                                    htmlFor="date-range1"
                                >
                                    <DateInput
                                        size="md"
                                        value={filterBy.seal_granted_at || ""}
                                        onChange={(e) => {
                                            setFilter({
                                                ...filterBy,
                                                seal_granted_at: e.target.value,
                                            });
                                        }}
                                    />
                                </FormElement>
                            </div>
                            <div>
                                <FormElement
                                    htmlFor="date-range2"
                                >
                                    <DateInput
                                        size="md"
                                        value={filterBy.seal_expires_at || ""}
                                        onChange={(e) => {
                                            setFilter({
                                                ...filterBy,
                                                seal_expires_at: e.target.value,
                                            });
                                        }}
                                    />
                                </FormElement>
                            </div>
                            <div>
                                <Select
                                    labels={{ 0: 'All', 1: 'Active', 2: 'Inactive'}}
                                    value={filterBy.active}
                                    className={styles.button}
                                    placeholder="Status"
                                    size="md"
                                    dropdownToggleRef={statusDropdownRef}
                                    onClick={e => {
                                        setFilter({
                                            ...filterBy,
                                            active: e.target.value,
                                        });
                                    }}
                                >
                                        <li value={0} key={'1-status'}>All</li>
                                        <li value={1} key={'2-status'}>Active</li>
                                        <li value={2} key={'3-status'}>Inactive</li>
                                </Select>
                            </div>
                            <span className={styles.clear} onClick={clearFilters}>
                            <i
                                className={`${styles["reset-filters"]} far fa-times`}
                                onClick={null}
                            />
                            </span>
                        </div>
                    </div>
                </PageHeader>

                <br />

                <FullDataTable
                    rowsData={orgs}
                    definitions={TableDefOrganizations}
                    dataType="organizations"
                    hideRowsPage={true}
                    serverPagination={true}
                    serverSort={{sortBy, setSort}}
                    dataSize={total}
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains("col-row-selector")
                        )
                            return;
                            // console.log(this.props.rowData.id);
                            // set cookie to selected org
                            Cookies.set('org', this.props.rowData.id);
                            // force reload new page
                            window.location.href = `/organization/${this.props.rowData.id}`;
                    }}
                />

            <br />

        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    UserOrgSiteReducer: state.UserOrgSiteReducer,
    SuperUserReducer: state.SuperUserReducer,

});

const mapDispatchToProps = {
    loadOrganizationsAction,
    setPaginationAction,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(DashboardSuper)
);
